import { ScopeType, ZoneType } from './types';
import { hasAnyScope, hasAnyZone } from './checkAccess';

export const getCanEditOrgPage = (zone: ZoneType, scope: ScopeType) =>
  hasAnyScope(scope) && hasAnyZone(zone);
